export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
export const SET_CART_COUNT = "SET_CART_COUNT";